// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__37YV2","subheader":"ReorderModal_subheader__1wDhO","listWrap":"ReorderModal_listWrap__1XO8v"};